import { SwitchWithLabel } from 'components/shared/Switch/Switch';
import { useAppSelector } from 'hooks/useAppSelector';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { useIntl } from 'react-intl';
import { FormIdProps } from 'shared/props';
import { missedDealFeedbackClientTradedChanged } from 'state/missed-deal-feeedback/actions';
import { getFeedbackIsClientNotTraded } from 'state/missed-deal-feeedback/selectors';

export function ClientTraded({ formId }: FormIdProps) {
  const { formatMessage } = useIntl();
  const isClientNotTraded = useAppSelector(s => getFeedbackIsClientNotTraded(s, formId));
  const dispatch = useThunkDispatch();
  return (
    <SwitchWithLabel
      id="missedDealFeedback-clientTraded"
      value={isClientNotTraded}
      onToggleSwitch={v => dispatch(missedDealFeedbackClientTradedChanged(formId, !v))}
      label={formatMessage({ id: 'missedDealFeedback.clientTraded' })}
      colSize={10}
      isAlignedLeft
      wrapText
    />
  );
}
